import React, { useState, useEffect } from "react"
import { Row, Col, Button } from "reactstrap"
import Switch from "react-switch"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import ReactPaginate from 'react-paginate';
import { Text } from "framework/validators/TextValidation"
const Offsymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      No
    </div>
  )
}

const OnSymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      Yes
    </div>
  )
}

const ProductBarcodeContent = ({ DataRow, Disabled, menuCode, setarRowBarcode, handleClearStatus }) => {


  const [postsPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)

  /*
  * @description This function is used to reset the page number to 1 when the clear button is clicked.
  */
  useEffect(() => {
    setCurrentPage(1)
  }, [handleClearStatus])

  /**
      * @description This function is used to change the value of perticular field in perticular row.
      * @param {string} value - value of the row.
      * @param {string} id - id of the row.
      * @param {string} element - element of the row.
   */

  const changeRowValueChanges = (value, id, element) => {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    const newObject = { ...DataRow[objectIndex], [element]: value };
    setarRowBarcode(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = newObject;
      return newDataRow;
    });
  };

  /**
      * @description This function is used to change the value of complete row.
      * @param {JSON} row - row of the table.
      * @param {string} id - id of the row.
   */

  function handleObjectChange(row, id) {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    setarRowBarcode(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = row;
      return newDataRow;
    });
  }


  /**
   * @description This function is used to add new row in the table.
   */

  function handleAddRowNestedBarcode() {

    // Check if there is any existing row with empty values
    const hasEmptyRow = DataRow.find(x => x.code == "" || x.desc == "");


    if (hasEmptyRow) {
      // If there is any row with empty values, do not add a new row
      return false;
    }

    const modifiedRows = [...DataRow]

    modifiedRows.push({
      id: modifiedRows.length + 1,
      code: "",
      locCodeDisable: false,
      RefNo: "",
      desc: "",
      state: true
    });

    const idModification = modifiedRows.map((item, index) => {
      item.id = index + 1;
      return item
    })

    setarRowBarcode(idModification)
  }

  /**
    * @description This function is used to remove the perticular row from the table.
    * @param {string} id - id of the row.
   */

  // function handleRemoveRowBarcode(id) {

  //   const modifiedRows = [...DataRow]
  //   const objectIndex = DataRow.findIndex(obj => obj.id === id);
  //   modifiedRows.splice(objectIndex, 1)

  //   if (modifiedRows.length == 0) {
  //     modifiedRows.push({ id: 1, code: "", desc: "", locCodeDisable: false, RefNo: "", state: true })
  //   }

  //   setarRowBarcode(modifiedRows)
  // }

  function handleRemoveRowBarcode(id) {
    const modifiedRows = [...DataRow];
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    modifiedRows.splice(objectIndex, 1);

    // Reassign unique IDs to the remaining rows
    for (let i = 0; i < modifiedRows.length; i++) {
      modifiedRows[i].id = i + 1;
    }

    if (modifiedRows.length === 0) {
      modifiedRows.push({
        id: 1,
        code: "",
        desc: "",
        locCodeDisable: false,
        RefNo: "",
        state: true
      });
    }

    const idModification = modifiedRows.map((item, index) => {
      item.id = index + 1;
      return item
    })

    setarRowBarcode(idModification);
  }

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };


  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = DataRow.slice(indexOfFirstPost, indexOfLastPost)

  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={12} className="mb-12-sm">
          <table style={{ fontSize: "11px" }} id={"BarcodeDet"}>
            <thead className="table-light">
              <tr>
                <th>Location Code </th>
                <th></th>
                <th>Location Name </th>
                <th>Reference Code </th>
                <th style={{ textAlign: 'center' }}>Is Active</th>
              </tr>
            </thead>
            <tbody disabled={true}>

              {currentPosts.map((formRow, key) => (
                <TableRow
                  FormRow={formRow}
                  Key={key}
                  RemoveRow={handleRemoveRowBarcode}
                  Disabled={Disabled}
                  menuCode={menuCode}
                  changeRowValueChanges={changeRowValueChanges}
                  handleObjectChange={handleObjectChange}
                  DataRow={DataRow}
                />
              ))}

            </tbody>
          </table>
          <Button
            disabled={Disabled}
            onClick={() => {
              handleAddRowNestedBarcode()
            }}
            color="success"
            className="mt-1"
            size="sm"
          >
            <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
          </Button>

        </Col>
      </Row>
      <Row>
        <Col md="12">
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            pageCount={Math.ceil(DataRow.length / postsPerPage)}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            forcePage={currentPage - 1}
            renderOnZeroPageCount={null}
            activeClassName={'active'}
            activeLinkClassName={'page-link'}
            containerClassName={'pagination justify-content-center pagination-sm'}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}
export default ProductBarcodeContent

const TableRow = ({ FormRow, Key, RemoveRow, Disabled, menuCode, changeRowValueChanges, handleObjectChange, DataRow }) => {

  const [code, setcode] = useState(FormRow.code != undefined ? FormRow.code : "")

  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)

  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)


  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [Datatablesub, SetDatatablesub] = useState([])
  const [groupFilter, SetGroupFilter] = useState('a')


  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]


  const Hed_SelectRowSearch = (e, row, isSelect, rowIndex) => {
    // if (CodeValidation(row.LOC_CODE, FormRow.id, 1)) {


    LocCodeSearch(row.LOC_CODE)
    // var currentRow = FormRow

    // currentRow.code = row.LOC_CODE
    // currentRow.desc = row.LOC_DESC
    // currentRow.locCodeDisable = true;
    // handleObjectChange(currentRow, FormRow.id)

    // } else {

    //   //changeRowValueChanges("", FormRow.id, "Paycode")
    //   setAlertDescription("This Location code already Used!!")
    //   setAlertConfirmOption(4)
    //   setsweetAlertShow(true)
    // }
    setmodal_xlarge(!modal_xlarge)
  }






  function LocCodeSearch(value) {

    if (value == "") return

    var currentRow = FormRow

    fetch(`${ApiURL}Locations/SearchCode/${value}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
    })
      .then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          const newArray = responseData.data[0]
          currentRow.code = newArray.code
          currentRow.desc = newArray.name
          currentRow.locCodeDisable = true;
          handleObjectChange(currentRow, FormRow.id)
        }
        else {
          currentRow.code = ""
          currentRow.desc = ""
          currentRow.RefNo = ""
          currentRow.locCodeDisable = false;
          handleObjectChange(currentRow, FormRow.id)

        }
      }).catch((error) => {
        console.log(error)
        currentRow.code = ""
        currentRow.desc = ""
        currentRow.RefNo = ""
        handleObjectChange(currentRow, FormRow.id)
      })

  }
  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }
  async function clickSearch() {
    tog_xlarge()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }



  /**
      *This function is used to check the LOCATION code is already exist or not
      * @param {string} PayCode - LOCATION code
      * @param {string} id - Row id
      * @param {string} onclickCheck - 0 - when click on the row, 1 - when click on the search button
   */




  const CodeValidation = (LocationCode, id, onclickCheck = 0) => {
    const filteredRows = DataRow.filter(item => item.code == LocationCode && item.id != id);

    if (onclickCheck == 1) {

      return filteredRows.length == 0;
    } else {

      return filteredRows.length <= 1;
    }
  };

  return (
    <tr key={FormRow.id}>
      <td style={{ width: "100px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="8"
              id={"txtBarcode" + Key}
              value={FormRow.code}
              disabled={Disabled ? true : FormRow.locCodeDisable}
              onChange={e => {

                let valBarcode = Text(
                  e.target,
                  30,
                  true,
                  true,
                  "any",
                  false
                )

                changeRowValueChanges(valBarcode, FormRow.id, "code")
              }}
              onBlur={(e) => {
                LocCodeSearch(e.target.value)
                // if (CodeValidation(e.target.value, "code" + Key)) {
                //   LocCodeSearch(e.target.value)
                // } else {
                //   setAlertDescription("This Location code already Used!!");
                //   FormRow.code=""
                //   setsweetAlertShow(true)
                //   return;
                // }
              }
              }
              onKeyPress={(e) => {
                if (e.key == "Enter") {
                  LocCodeSearch(e.target.value)
                }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "30px" }}>
        <Row className="mb-0">
          <Col md="12">
            <Button
              outline
              color="success"
              disabled={Disabled ? true : FormRow.locCodeDisable}
              id={"btnBarcodeSearch" + Key}
              onClick={clickSearch}
              size="sm"
            >
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </td>
      <td style={{ width: "300px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={true}
              maxLength="8"
              id={"txtBardesc" + Key}
              value={FormRow.desc}
              onChange={e => {
                changeRowValueChanges(e.target.value, FormRow.id, "desc")
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "300px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={Disabled}
              maxLength="50"
              id={"txtRefNo" + Key}
              value={FormRow.RefNo}

              onChange={e => {
                // if (CodeValidation(e.target.value, "txtRefNo" + Key)) {
                changeRowValueChanges(e.target.value, FormRow.id, "RefNo")
                // } else {
                //   setAlertDescription("This	Reference Code already used")
                //   setAlertConfirmOption(4)
                //   setsweetAlertShow(true)
                // }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>

      <td style={{ width: "80px", margin: "auto", textAlign: "center" }}>
        <Row className="mb-0">
          <Col md="12">
            <Switch
              uncheckedIcon={<Offsymbol />}
              checkedIcon={<OnSymbol />}
              onColor="#626ed4"
              height={23}
              handleDiameter={15}
              onChange={(e) => {
                changeRowValueChanges(e, FormRow.id, "state")
              }}
              checked={FormRow.state}
              id={"swBarCodereq" + Key}
              disabled={Disabled}
            />
          </Col>
        </Row>
      </td>

      <td>
        <Row className="mb-0">
          <Col md="1">
            <Button
              outline
              color="danger"
              id={"btnBarcodeDelete" + Key}
              onClick={e => {
                RemoveRow(FormRow.id)
              }}
              size="sm"
              disabled={Disabled}
            >
              <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
            </Button>
          </Col>{" "}

          <DPSearchBoxDynamic
            searchData={Datatablesub}
            columns={[]}
            defaultSorted={defaultSorted}
            mainTitle={"Location Search"}
            SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
            isOpen={modal_xlarge}
            toggle={tog_xlarge}
            getSelect={Hed_SelectRowSearch}
            APIURL={ApiURL}
            URLPath={"LOCATION"}
            MenuCode={menuCode}
            KeyVal={'LOC'}
            searchBy={'LOC_CODE'}
            FilterStr={groupFilter}
          />

          <DPAlert
            confirm_both={sweetAlertShow}
            title={"Product Master !"}
            description={AlertDescription}
            showCancel={false}
            btnColor={"success"}
            cancelColor={"danger"}
            onConfirm={() => {
              setsweetAlertShow(false)
              changeRowValueChanges("", FormRow.id, "RefNo")
            }}
            btnYes={"OK"}
          />
        </Row>
      </td>
    </tr>
  )
}
